import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {CronJobName, CronJobResult} from "./cron-job.model";
import {Apollo} from "apollo-angular";
import {CronGqlModel} from "./cron.gql-model";
import {Observable, ReplaySubject} from "rxjs";

@Injectable()
export class CronAdminService {
  private url: string = "/api/cron-admin";

  private subject: ReplaySubject<any> = new ReplaySubject<any>();
  logEntries: Observable<any> = this.subject.asObservable();

  constructor(private http: HttpClient, private apollo: Apollo) {
    this.apollo
      .subscribe({
        query: CronGqlModel.query,
        fetchPolicy: "no-cache",
      })
      .pipe(CronGqlModel.mapper)
      .subscribe(this.subject);
  }

  callCronJob(job: CronJobName): Promise<CronJobResult> {
    return this.http.post<CronJobResult>(`${this.url}/${job}`, {})
      .toPromise();
  }
}
